import { FunctionComponent } from "react";
import styles from "./FormExtraItem.module.scss";
import { Icon } from "@rmwc/icon";

type ownProps = {
  icon: string;
  title?: string;
  price?: string;
  description?: string;
  active: boolean;
  onClick?: () => void;
  style?: object;
};

const FormExtraItem: FunctionComponent<ownProps> = (props: ownProps) => {
  const { icon, title, price, description, active, style } = props;
  return (
    <div
      className={styles.FormExtraItem + " " + (active ? styles.active : "")}
      onClick={() => {
        props.onClick && props.onClick();
      }}
      style={style}
    >
      <div className={styles.icon}>
        <Icon icon={icon} />
      </div>
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        {price && <div className={styles.price}>{price}</div>}
        {description && <div className={styles.description}>{description}</div>}
      </div>
    </div>
  );
};

export { FormExtraItem, FormExtraItem as default };
